import { Spin } from "antd";
import photo from "../../../../assets/background/photo_icon.png"
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { ButtonLZ } from "../../../components/design/Buttons/ButtonLZ";
import PhotosSwiper from "../../../components/design/Swiper/PhotosSwiper";

export const MediaCarrousel = (props: { locationId: string }) => {

    const { projectGroup } = useAuth();

    const { data: media, isLoading: mediaLoading = true }: any = useFetch(
		`${process.env.REACT_APP_API}/projects/` + projectGroup.project + `/${props.locationId}/mediaItems`,
		{},
		[],
	);
    return (
        <div>
            {mediaLoading ? 
            <div style = {{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px'}}><Spin/></div>            
            :
            media?.list?.length > 0 ? (
                <PhotosSwiper mediaItems={media?.list} />
            ) : (
                <div
                    style={{
                        position: 'relative',
                        height: '300px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <h1 style={{ color: '#AAADAE', fontWeight: 700, fontSize: '40px' }}>
                        No tienes fotos!
                    </h1>                    
                    
                    {/* <img src={circleGreen} style={{ position: 'absolute', width: '40px', bottom: '15%', left: '15%' }} />
                    <img src={donutYellow} style={{ position: 'absolute', width: '270px', bottom: 0, right: 0 }} /> */}
                    <img src={photo} style={{ position: 'absolute', width: '100px', top: '5%', right: '5%' }} />
                    <img src={photo} style={{position: 'absolute',width: '70px',bottom: '20%',left: 0, transform: 'rotate(-50deg)' }}/>
               
                    {/* <img src={bluePill} style={{ position: 'absolute', width: '80px', bottom: '10%', right: 0, transform: 'rotate(100deg)'}} /> */}
                </div>
            )}
        </div>
    );
};